<template>
    <v-container v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            <statistical-member-or-senator-selector :value="selectedMpOrSenator" @input="selectedMpOrSenator = $event" />        
            <br/>
            
            <chart :chartData="chartData"/> 
            <br/>
            <v-data-table 
                :headers="headers" 
                :items="items"
                :rows-per-page-items="rowsPerPageItems"
                :hide-actions="true"
                item-key="$id"
                :loading="loading"
                :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                :hide-headers="isMobile"
                :custom-sort="customSort"
                :disable-initial-sort="true">
                <template v-slot:items="props">
                    <template v-if="isMobile">
                        <tr>
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item">
                                        <h3><a @click="handlePartyClick(props.item.Party)">{{ props.item.Party }}</a></h3>
                                    </div>
                                    <div class="flex-item flex-item-col flex-item-col-70" data-label="State or Territory Legislatures">
                                        <a @click="handleStateClick(props.item.Party)">{{ props.item.State }}</a>
                                    </div>
                                    <div class="flex-item flex-item-col flex-item-col-30" data-label="Local Govt">
                                        <a @click="handleLocalClick(props.item.Party)">{{ props.item.Local }}</a>
                                    </div>
                                    <div class="flex-item" data-label="Total party members in Parliament">
                                        <a @click="handlePartyClick(props.item.Party)">{{ props.item.Total }}</a>
                                    </div>
                                    <div class="flex-item" data-label="Proportion of all members (%)">
                                        {{ generateInnerTable(props.item).find(i => i.name == 'Proportion of all members (%)').value | percentage }}
                                    </div>
                                    <div class="flex-item" data-label="Corresponding proportion, previous parliament (%)">
                                        {{ generateInnerTable(props.item).find(i => i.name == 'Corresponding proportion, previous parliament (%)').value | percentage }}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <tr v-else @click="props.expanded = !props.expanded">
                        <td style="padding-right: 0"><v-icon>{{ props.expanded ? 'expand_less' : 'expand_more' }}</v-icon></td>
                        <td class="text-xs-left"><a @click="handlePartyClick(props.item.Party)">{{ props.item.Party }}</a></td>
                        <td class="text-xs-left"><a @click="handleStateClick(props.item.Party)">{{ props.item.State }}</a></td>
                        <td class="text-xs-left"><a @click="handleLocalClick(props.item.Party)">{{ props.item.Local }}</a></td>
                        <td class="text-xs-left"><a @click="handlePartyClick(props.item.Party)">{{ props.item.Total }}</a></td>
                    </tr>
                </template>
                <template v-slot:expand="props">
                    <div class="pa-3">
                        <v-data-table :headers="[
                            { text: '', value: ''}, 
                            { text: '', value: '' }
                            ]"
                            :disable-initial-sort="true"
                            :hide-actions="true"
                            :hide-headers="true"
                            :items="generateInnerTable(props.item)">
                            <template v-slot:items="propsInner">
                                <tr>
                                    <td>{{ propsInner.item.name }}</td>
                                    <td v-if="propsInner.item.name === 'Proportion of all members (%)' || propsInner.item.name === 'Corresponding proportion, previous parliament (%)'">{{ propsInner.item.value | percentage }}</td>
                                    <td v-else-if="propsInner.item.name === 'State or territory legislatures'"><a @click="handleStateClick(props.item.Party)">{{ props.item.State }}</a></td>
                                    <td v-else-if="propsInner.item.name === 'Local'"><a @click="handleLocalClick(props.item.Party)">{{ props.item.Local }}</a></td>
                                    <td v-else-if="propsInner.item.name === 'Total'"><a @click="handlePartyClick(props.item.Party)">{{ props.item.Total }}</a></td>
                                    <td v-else>{{ propsInner.item.value }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </template>
            </v-data-table>
            <br/>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout> 
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import StatisticalMemberOrSenatorSelector from './StatisticalMemberOrSenatorSelector.vue';
import Chart from './Chart.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        Chart,
        StatisticalHeader,
        StatisticalMemberOrSenatorSelector
    },
    methods: {
        generateInnerTable(item) {
            const value = [
                { name: 'State or territory legislatures', value: item.State },
                { name: 'Local', value: item.Local },
                { name: 'Total', value: item.Total },
                { name: 'Total party members in parliament', value: item.TotalNumberOfMembers },
                { name: 'Proportion of all members (%)', value: item.ProportionOfAllMembers },
                { name: 'Corresponding proportion, previous parliament (%)', value: item.CorrespondingProportionPreviousParliament }
            ]
            return value;
        },
        initialiseItems() {
            this.loading = true;
            const parliamentarianType = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];
            const url = `StatisticalInformation/PriorService?parliamentariantype=${parliamentarianType}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                });
        },
        filterMpOrSenator() {
            this.initialiseItems();
        },
        handlePartyClick(partyId) {
            const query = {
                "logicalOperator":"all",
                "children":[
                    {
                        "type":"query-builder-group",
                        "query":
                            { "logicalOperator":"any", "children":[{"type":"query-builder-rule","query":{"rule":"government.service.state","selectedOperator":"of","selectedOperand":"State/Territory Government Service","value":null}},
                            {"type":"query-builder-rule","query":{"rule":"government.service.local","selectedOperator":"of","selectedOperand":"Local Government Service","value":null}}]}},
                            {"type":"query-builder-rule","query":{"rule":"inCurrentParliament","selectedOperand":"In current Parliament","value":"Yes"}}]};
            if (partyId) {
                var partyVal = "[{\"field\":\"RefList1\",\"value\":[],\"simpleValue\":[],\"textValue\":\"" + partyId + "\",\"dateValue\":null,\"fieldType\":null}]";
                query.children.push({"type":"query-builder-rule","query":{"rule":"parties.represented.new","selectedOperator":"of","selectedOperand":"Parties represented", "value":partyVal }});
            }
            this.handleParliamentarianType(query);
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleStateClick(partyId) {
            const query = {
                "logicalOperator":"all",
                "children":[
                    {"type":"query-builder-rule","query":{"rule":"government.service.state","selectedOperator":"of","selectedOperand":"Local Government Service","value":null}},
                    {"type":"query-builder-rule","query":{"rule":"inCurrentParliament","selectedOperand":"In current Parliament","value":"Yes"}}]};
            
            if (partyId) {
                var partyVal = "[{\"field\":\"RefList1\",\"value\":[],\"simpleValue\":[],\"textValue\":\"" + partyId + "\",\"dateValue\":null,\"fieldType\":null}]";
                query.children.push({"type":"query-builder-rule","query":{"rule":"parties.represented.new","selectedOperator":"of","selectedOperand":"Parties represented", "value":partyVal }});
            }
            this.handleParliamentarianType(query);
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleLocalClick(partyId) {
            const query = {
                "logicalOperator":"all",
                "children":[
                    {"type":"query-builder-rule","query":{"rule":"government.service.local","selectedOperator":"of","selectedOperand":"Local Government Service","value":null}},
                    {"type":"query-builder-rule","query":{"rule":"inCurrentParliament","selectedOperand":"In current Parliament","value":"Yes"}}]};
            
            if (partyId) {
                var partyVal = "[{\"field\":\"RefList1\",\"value\":[],\"simpleValue\":[],\"textValue\":\"" + partyId + "\",\"dateValue\":null,\"fieldType\":null}]";
                query.children.push({"type":"query-builder-rule","query":{"rule":"parties.represented.new","selectedOperator":"of","selectedOperand":"Parties represented", "value":partyVal }});
            }
            this.handleParliamentarianType(query);
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleParliamentarianType(query) {
            if (this.selectedMpOrSenator.length == 1) {
                const selected = this.selectedMpOrSenator[0];
                switch (selected) {
                    case 'senator':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"senator"}});
                        break;
                    case 'mp':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"member"}});
                }
            }
        },
        customSort(items, index, isDesc) {
            items.sort((a, b) => {
                if (a.Party ===  'Total') {
                    return 1;
                }
                if (index === "Range.Floor") {
                    // for items, get party
                    // a is less than b is -1
                    // a is greater than b is 1
                    if (a.Range.Name ===  'Not stated') {
                        return isDesc ? 1 : -1
                    }
                    if (b.Range.Name ===  'Not stated') {
                        return isDesc ? -1 : 1
                    }
                    const aRange = a.Range.Floor || 0;
                    const bRange = b.Range.Floor || 0;
                    if (!isDesc) {
                        return aRange < bRange ? -1 : 1;
                    } else {
                        return bRange < aRange ? -1 : 1;
                    }
                } else {
                    if (!isDesc) {
                        return a[index] < b[index] ? -1 : 1;
                    } else {
                        return b[index] < a[index] ? -1 : 1;
                    }
                }
            });
            return items;
        },        
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items.map(i => 
            ({ 
                Party: i.Party, 
                'State or Territory Legislatures': i.State, 
                'Local Govt': i.Local,
                'Total': i.Total,
                'Total number of members': i.TotalNumberOfMembers,
                'Proportion of all members (%)': this.$options.filters.percentage(i.ProportionOfAllMembers),
                'Corresponding proportion, previous Parliament (%)': this.$options.filters.percentage(i.CorrespondingProportionPreviousParliament) }));
            let headers = this.headers.map(h => h.text);
            const filename = 'Prior elected service in government';
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },  
            
    }, 
    mounted() {
        this.onResize();
    },
    computed: {
        csvDownloadIcon(){
            return this.csvDownloading ? 'cached' : 'text_snippet';
        },
        csvDownloadClass(){
            let csvClass = 'mr-1';
            if (this.csvDownloading){
                csvClass = csvClass + ' loading'
            }
            return csvClass;
        },
        chartData() {
            return {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: this.title
                },
                xAxis: {
                    categories: this.items.filter(i => i.Party !== 'Total').map(i => i.Party)
                },
                yAxis: {
                    title: {
                        text: this.title
                    }
                },
                exporting: {
                    filename: 'Prior elected service in government',
                    sourceWidth: 1200
                },
                series: [{
                    name: 'State or Territory Legislatures',
                    data: this.items.filter(i => i.Party !== 'Total').map(i => i.State)
                }, {
                    name: 'Local Govt',
                    data: this.items.filter(i => i.Party !== 'Total').map(i => i.Local)
                }
                ]
            }
        }
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
        title: 'Prior elected service in government—current Parliament',
        isMobile: false,
        headers: [
            {
                text: '',
                sortable: false,
                value: 'Party'
            },
            {
                text: 'Party',
                value: 'Party'
            },
            {
                text: 'State or Territory Legislatures',
                value: 'State' 
            },
            {
                text: 'Local Govt',
                value: 'Local'
            },
            {
                text: 'Total',
                value: 'Total'
            }
        ],
        items: [],
        search: '',
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        rowsPerPageItems: [ {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }       
}
</script>